/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 09:50:00 
 * @Last Modified by: jingyu.yang
 * @Last Modified time: 2021-12-17 12:01:43
 */
import { post, getJson } from "./index";
/**
 * 获取空间
 * @param {*} type 
 * @returns 
 */
export const getSpace = type => getJson(config.cvds + "meet_sharing_file/space", type);
/**
 * 获取列表
 * @param {*} p 
 * @returns 
 */
export const getFileLists = p => post(config.cvds + 'meet_sharing_file/list', p);

/**
 * 上传任务
 * @param {*} p 
 * @returns 
 */
export const task = p => post(config.cvds + 'meet_sharing_file/preUpload', p);

/**
 * 上传
 * @param {*} p 
 * @param {*} conf 
 * @returns 
 */
export const upload = (p, conf) => post(config.rc + 'external/file/break/upload', p, {}, conf);

/**
 * 上传结束，开始转码
 * @param {*} p 
 * @returns 
 */
export const uploadFinish = p => post(config.rc + 'external/file/break/upload/finish', p);

/**
 * 删除文件
 * @param {*} p 
 * @returns 
 */
export const deleteFile = p => post(config.cvds + 'meet_sharing_file/delete', p);

/**
 * 预览文件
 * @param {*} p 
 * @returns 
 */
export const getPreview = p => getJson(config.cvds + 'meet_sharing_file/viewDomain/' + p, {});

/**
 * 开始共享
 * @param {*} p 
 * @returns 
 */
export const shareFileStart = p => post(config.cvds + 'datashare/doc/share/call', p);

/**
 * 获取共享批注信息
 * @param {*} p 
 * @returns 
 */
export const getShareInfo = (roomId, annotation = 1) => getJson(config.cvds + `datashare/doc/share/info?roomId=${roomId}&annotation=${annotation}`, {})

/**
 * 获取权限
 * @param {*} p 
 * @returns 
 */
export const shareAnothor = p => getJson(config.cvds + 'datashare/doc/share/info?roomId=' + p, {});

/**
 * 获取插播播放地址url
 * @param {string} fileId
 * @returns 
 */
export const getUrl = (fileId) => post(config.cvds + 'meet_sharing_media/download/url', {
  fileId,
  expired: 36000,
})

/**
 * @function cloudInfo
 * @desc 共享状态信息
 * @param {string} roomId 直播id 
 * @returns {Promise}
 */
export const cloudInfo = (roomId) => getJson(config.cvds + 'datashare/cloud/info', {
  roomId
})

/**
 * @function cloudSwitch
 * @desc 共享状态切换
 * @param {string} data.roomId 直播id 
 * @param {string} data.type 可用值:doc,wb
 * @returns {Promise}
 */
export const cloudSwitch = (data) => post(config.cvds + 'datashare/cloud/switch', data)